<template>
  <Modal
    v-model="visible"
    :title="modalTitle"
    @on-cancel="handleCancel"
    :mask-closable="false"
    width="700"
  >
    <Form v-if="visible" :model="formData" :label-width="120" ref="formRef">
      <!-- 推送弹窗 -->
      <FormItem
        label="推送活动"
        prop="popupId"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请选择活动',
            trigger: 'change'
          }
        ]"
      >
        <Select
          ref="selectRef"
          v-model="formData.popupId"
          placeholder="请搜索并选择弹窗"
          :disabled="readonly"
          :loading="popupLoading"
          filterable
        >
          <Option
            v-for="item in popupOptions"
            :key="item.id"
            :value="item.id"
            :label="item.popupName"
          >
            <div class="popup-option-item">
              <Poptip trigger="hover" placement="left" transfer width="220">
                <Icon
                  type="ios-help-circle-outline"
                  size="16"
                  class="popup-preview-icon"
                />
                <template #content>
                  <div class="popup-preview-card">
                    <!-- 类型 4(赠币)/5 组合预览：背景图+按钮图 -->
                    <template v-if="isCompositePopup(item)">
                      <div
                        class="popup-composite-wrapper"
                        v-if="item.popupFileUrl"
                      >
                        <img
                          :src="item.popupFileUrl"
                          class="popup-preview-img"
                        />
                        <div
                          class="popup-composite-btn"
                          v-if="item.buttonFileUrl"
                        >
                          <img
                            :src="item.buttonFileUrl"
                            class="popup-composite-btn-img"
                          />
                        </div>
                      </div>
                      <div v-else class="popup-preview-empty">暂无预览图</div>
                    </template>
                    <!-- 类型 1-3 / 解锁短剧 单图预览 -->
                    <template v-else>
                      <img
                        v-if="getPopupPreviewImg(item)"
                        :src="getPopupPreviewImg(item)"
                        class="popup-preview-img"
                      />
                      <div v-else class="popup-preview-empty">暂无预览图</div>
                    </template>
                    <div class="popup-preview-type">
                      {{ getPopupTypeLabel(item.popupType) }}
                    </div>
                  </div>
                </template>
              </Poptip>
              <span>{{ item.popupName }}</span>
            </div>
          </Option>
        </Select>
      </FormItem>

      <!-- 推送人群 -->
      <FormItem label="推送人群">
        <RadioGroup
          v-model="formData.crowdLimit"
          type="button"
          button-style="solid"
          :disabled="readonly"
          @on-change="handleCrowdLimitChange"
        >
          <Radio :label="1" :disabled="readonly">不限</Radio>
          <Radio :label="0" :disabled="readonly">选择人群包</Radio>
        </RadioGroup>
        <Select
          v-if="!formData.crowdLimit"
          v-model="formData.crowdIds"
          placeholder="请输入人群包名称搜索"
          :disabled="readonly"
          :loading="crowdLoading"
          filterable
          multiple
          style="margin-top: 10px"
        >
          <Option
            v-for="item in crowdOptions"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >
            <Poptip
              trigger="hover"
              placement="left"
              transfer
              word-wrap
              width="350"
            >
              <span>{{ item.name }}</span>
              <template #content>
                <div class="crowd-preview-card">
                  <div class="crowd-preview-title">{{ item.name }}</div>
                  <div class="crowd-preview-body">
                    <div
                      v-if="item.registerTimeDisplay"
                      class="crowd-preview-row"
                    >
                      <span class="crowd-preview-label">注册时间</span>
                      <span class="crowd-preview-value">
                        {{ item.registerTimeDisplay }}
                      </span>
                    </div>
                    <div v-if="item.payTypeName" class="crowd-preview-row">
                      <span class="crowd-preview-label">付费类型</span>
                      <span class="crowd-preview-value">
                        {{ item.payTypeName }}
                      </span>
                    </div>
                    <div
                      v-if="
                        item.todayLogin !== null &&
                        item.todayLogin !== undefined
                      "
                      class="crowd-preview-row"
                    >
                      <span class="crowd-preview-label">当日登录</span>
                      <span class="crowd-preview-value">
                        {{ item.todayLogin ? '是' : '否' }}
                      </span>
                    </div>
                    <div v-if="item.deviceSysName" class="crowd-preview-row">
                      <span class="crowd-preview-label">操作设备</span>
                      <span class="crowd-preview-value">
                        {{ item.deviceSysName }}
                      </span>
                    </div>
                    <div v-if="item.channelNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">渠道</span>
                      <span class="crowd-preview-value">{{
                        item.channelNames
                      }}</span>
                    </div>
                    <div v-if="item.langNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">语言</span>
                      <span class="crowd-preview-value">{{
                        item.langNames
                      }}</span>
                    </div>
                    <div v-if="item.countryNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">国家</span>
                      <div class="crowd-country-text-wrapper">
                        <Tooltip
                          style="width: 100%; display: block"
                          :content="item.countryNames"
                          :max-width="300"
                          placement="top"
                          transfer
                        >
                          <span class="crowd-preview-value ellipsis-text">
                            {{ item.countryNames }}
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Poptip>
          </Option>
        </Select>
      </FormItem>

      <!-- 用户停留时长 -->
      <FormItem label="用户停留时长">
        <Select
          v-model="formData.watchingDurationType"
          placeholder="请选择"
          :disabled="readonly"
          style="width: 150px"
          @on-change="handleDurationTypeChange"
        >
          <Option
            v-for="item in durationTypeOptions"
            :key="item.dictValue"
            :value="Number(item.dictValue)"
          >
            {{ item.dictName }}
          </Option>
        </Select>
        <template v-if="showDurationInput">
          <InputNumber
            v-model="formData.durationMin"
            :min="formData.watchingDurationType == 2 ? 1 : 0"
            :max="9999"
            :precision="0"
            style="width: 100px; margin-left: 10px"
            :disabled="readonly"
            :placeholder="
              formData.watchingDurationType == 2 ? '最大值' : '最小值'
            "
          />
          <span v-if="showDurationRange" style="margin: 0 5px">至</span>
          <InputNumber
            v-if="showDurationRange"
            v-model="formData.durationMax"
            :min="0"
            :max="9999"
            :precision="0"
            style="width: 100px"
            :disabled="readonly"
            :placeholder="'最大值'"
          />
          <span style="margin-left: 5px; color: #999">秒</span>
        </template>
      </FormItem>

      <!-- 触发页面 -->
      <FormItem
        label="触发页面"
        prop="position"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请选择触发页面',
            trigger: 'change'
          }
        ]"
      >
        <Select
          v-model="formData.position"
          placeholder="请选择触发活动的页面"
          :disabled="readonly"
          @on-change="handlePositionChange"
        >
          <Option
            v-for="item in triggerPageOptions"
            :key="item.dictValue"
            :value="Number(item.dictValue)"
          >
            {{ item.dictName }}
          </Option>
        </Select>
      </FormItem>

      <!-- 触发操作 -->
      <FormItem
        label="触发操作"
        prop="triggerTiming"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请选择触发操作',
            trigger: 'change'
          }
        ]"
      >
        <Select
          v-model="formData.triggerTiming"
          placeholder="请选择页面内触发弹窗的操作"
          :disabled="readonly || !formData.position"
        >
          <Option
            v-for="item in currentTriggerActions"
            :key="item.dictValue"
            :value="Number(item.dictValue)"
            :label="item.dictName"
          >
            <div class="action-option-item">
              <Poptip
                v-if="item.previewDesc"
                trigger="hover"
                placement="left"
                transfer
                width="200"
              >
                <Icon
                  type="ios-help-circle-outline"
                  size="16"
                  class="action-preview-icon"
                />
                <template #content>
                  <div class="action-preview-card">
                    <img
                      v-if="item.previewImg"
                      :src="item.previewImg"
                      style="
                        width: 100%;
                        max-height: 250px;
                        object-fit: contain;
                        margin-top: 4px;
                        border-radius: 4px;
                      "
                    />
                    <div v-else class="action-preview-tip">预览图待补充</div>
                  </div>
                </template>
              </Poptip>
              <span>{{ item.dictName }}</span>
            </div>
          </Option>
        </Select>
      </FormItem>

      <!-- 每日触发次数 -->
      <FormItem
        label="每日触发次数"
        prop="popupCount"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请输入每日触发次数',
            trigger: 'blur'
          }
        ]"
      >
        <div class="popup-count-mode-row">
          <RadioGroup
            v-model="popupCountMode"
            type="button"
            button-style="solid"
            :disabled="readonly"
            @on-change="handlePopupCountModeChange"
          >
            <Radio :label="0" :disabled="readonly">不限</Radio>
            <Radio :label="1" :disabled="readonly">限制次数</Radio>
          </RadioGroup>
        </div>
        <div v-if="popupCountMode === 1" class="popup-count-input-row">
          <InputNumber
            v-model="formData.popupCount"
            :min="1"
            :max="99"
            :precision="0"
            class="popup-count-input"
            :disabled="readonly"
          />
          <span class="popup-count-unit">次/天</span>
        </div>
      </FormItem>

      <!-- 优先级 -->
      <FormItem
        label="优先级"
        prop="priority"
        :rules="[
          {
            required: true,
            type: 'number',
            message: '请输入优先级',
            trigger: 'blur'
          }
        ]"
      >
        <InputNumber
          v-model="formData.priority"
          :min="1"
          :max="9999"
          :precision="0"
          style="width: 200px"
          :disabled="readonly"
        />
        <span style="margin-left: 10px; color: #999">数值越小, 优先级越高</span>
      </FormItem>

      <!-- 推送规则名称 -->
      <FormItem
        label="推送规则名称"
        prop="popupRuleName"
        :rules="[
          { required: true, message: '请输入规则名称', trigger: 'blur' }
        ]"
      >
        <Input
          v-model="formData.popupRuleName"
          placeholder="仅用于后台展示"
          :disabled="readonly"
          :maxlength="100"
        />
      </FormItem>
    </Form>

    <template #footer v-if="!readonly">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" :loading="loading" @click="handleSubmit"
        >保存</Button
      >
    </template>
  </Modal>
</template>

<script>
import { addPush, editPush } from '@/api/crowdPush'
import { getCrowdList } from '@/api/crowd'
import { getPopupList } from '@/api/popup'
import { getDictionaryList } from '@/api/dictionary'
import { debounce } from 'lodash'
import discountPopupImgCoin from '@/assets/images/discount_popup_coin.png'
import discountStyle1Img from '@/assets/images/1.png'
import discountStyle2Img from '@/assets/images/2.png'
import discountStyle3Img from '@/assets/images/3.png'
import discountStyle4Img from '@/assets/images/4.png'
import discountStyle5Img from '@/assets/images/5.png'
import dramaPopupCenterImg from '@/assets/images/drama_popup_center.png'
import dramaPopupBottomImg from '@/assets/images/drama_popup_bottom.png'
import loginPopupImg from '@/assets/images/login_popup.jpg'
import unlockImage from '@/assets/images/unlock.png'

import backButtonImg from '@/assets/images/backButton.jpg'
import vipBack from '@/assets/images/vipBack.png'
import walletBack from '@/assets/images/walletBack.png'
import popupPanelImg from '@/assets/images/popupPanel.jpg'
import closePanelImg from '@/assets/images/closePanel.jpg'
import cancelPayImg from '@/assets/images/cancelPay.jpg'
import { getAllowedTriggerTimingValues } from './triggerScene'

// 弹窗类型预览图直接映射(仅供没有细分条件的类型使用)
const POPUP_TYPE_PREVIEW = {
  3: loginPopupImg
}

const POPUP_TYPE_LABELS = {
  1: '折扣弹窗',
  2: '剧集推荐弹窗',
  3: '登录弹窗',
  4: '激励视频弹窗',
  5: '自定义弹窗'
}

const TRIGGER_PAGE_OPTIONS = [] // 依靠字典接口获取
const TRIGGER_ACTION_OPTIONS = [] // 依靠字典接口获取

export default {
  name: 'PushEditModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      crowdLoading: false,
      popupLoading: false,
      crowdOptions: [],
      popupOptions: [],
      durationTypeOptions: [],
      showDurationInput: false,
      showDurationRange: false,
      popupCountMode: 1,
      lastLimitedPopupCount: 1,
      expandedCrowdIds: [],
      triggerPageOptions: [],
      triggerActionOptions: [],
      formData: {
        popupRuleName: '',
        position: null,
        triggerTiming: null,
        watchingDurationType: 0,
        durationMin: null,
        durationMax: null,
        crowdIds: [],
        crowdLimit: 1,
        popupCount: 1,
        popupId: null,
        priority: 1
      }
    }
  },
  computed: {
    modalTitle() {
      if (this.readonly) return '查看弹窗规则'
      return (this.formData.id ? '编辑' : '新增') + '活动推送'
    },
    currentTriggerActions() {
      // Return actions allowed for current position based on the screenshot enums.
      if (!this.formData.position) return []

      const pos = this.formData.position
      const allowedTimings = getAllowedTriggerTimingValues(pos)

      return this.triggerActionOptions
        .filter((item) => allowedTimings.includes(Number(item.dictValue)))
        .map((item) => {
          let previewImg = null
          let previewDesc = null
          if (item.dictValue == 5) {
            previewImg = popupPanelImg
            previewDesc = '观看剧集时弹出付费墙面板'
          } else if (item.dictValue == 6) {
            previewImg = closePanelImg
            previewDesc = '点击付费墙空白处关闭面板'
          } else if (item.dictValue == 7) {
            previewImg = cancelPayImg
            previewDesc = '点击取消或关闭App Store订阅弹窗'
          } else if (item.dictValue == 10) {
            if (pos === 2) {
              previewImg = backButtonImg
              previewDesc = '播放器左上角返回按钮'
            } else if (pos === 5) {
              previewImg = vipBack
              previewDesc = '会员页左上角返回按钮'
            } else if (pos === 6) {
              previewImg = walletBack
              previewDesc = '钱包页左上角返回按钮'
            }
          }
          return {
            ...item,
            previewImg,
            previewDesc
          }
        })
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val
        if (val) {
          this.fetchDictionaries()
          this.fetchCrowdPackages()
          this.searchPopups('')

          if (this.data.id) {
            this.mapDataToForm(this.data)
          } else {
            this.resetFormData()
          }
        }
      }
    },
    visible(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    async fetchDictionaries() {
      try {
        const [durationRes, positionRes, timingRes] = await Promise.all([
          getDictionaryList({ dictTopic: 'WATCHING_DURATION_TYPE' }),
          getDictionaryList({ dictTopic: 'POPUP_POSITION' }),
          getDictionaryList({ dictTopic: 'POPUP_TRIGGER_TIMING' })
        ])
        this.durationTypeOptions = durationRes.data.records || []
        this.triggerPageOptions = positionRes.data.records || []
        this.triggerActionOptions = timingRes.data.records || []
      } catch (e) {
        this.$Message.error('获取字典数据失败')
      }
    },
    async fetchCrowdPackages() {
      this.crowdLoading = true
      try {
        const { data } = await getCrowdList({ current: -1, size: -1 })
        this.crowdOptions = data.records || []
      } catch (e) {
        this.$Message.error('获取人群包列表失败')
      } finally {
        this.crowdLoading = false
      }
    },
    searchPopups: debounce(async function (query) {
      if (this.popupLoading) return
      this.popupLoading = true
      try {
        const params = {
          current: 1,
          size: 100,
          popupName: query,
          popupStatus: 1
        }
        const { data } = await getPopupList(params)
        this.popupOptions = data.records || []
      } catch (e) {
        this.$Message.error('获取弹窗列表失败')
      } finally {
        this.popupLoading = false
      }
    }, 500),
    getPopupPreviewImg(item) {
      // 类型 1: 折扣弹窗
      if (item.popupType === 1) {
        // 金币折扣弹窗
        if (item.goodsType === 0) return discountPopupImgCoin
        // 订阅折扣弹窗
        const styleImages = {
          1: discountStyle1Img,
          2: discountStyle2Img,
          3: discountStyle3Img,
          4: discountStyle4Img,
          5: discountStyle5Img
        }
        return styleImages[item.discountStyle] || discountStyle1Img
      }
      // 类型 2: 剧集推荐弹窗
      if (item.popupType === 2) {
        return item.popupStyle === 1 ? dramaPopupCenterImg : dramaPopupBottomImg
      }
      // 类型 3 使用静态预览图
      if (item.popupType === 3) {
        return loginPopupImg
      }
      // 类型 4 激励视频弹窗：rewardType=2 为解锁短剧，使用静态图
      if (item.popupType === 4 && item.rewardType === 2) {
        return unlockImage
      }
      // 类型 4(奖励金币)/5 使用上传的弹窗背景图
      return item.popupFileUrl || ''
    },
    getPopupTypeLabel(type) {
      return POPUP_TYPE_LABELS[type] || ''
    },
    isCompositePopup(item) {
      // 自定义弹窗(5) 和 激励视频-赠币(4, rewardType≠2) 需要组合背景图+按钮图
      if (item.popupType === 5) return true
      if (item.popupType === 4 && item.rewardType !== 2) return true
      return false
    },
    handleCrowdLimitChange(val) {
      if (val) {
        this.formData.crowdIds = []
      }
    },
    handlePositionChange() {
      // 切换触发页面时清空触发操作
      this.formData.triggerTiming = null
    },
    handleDurationTypeChange(val) {
      if (val === 0 || val === null || val === undefined) {
        this.showDurationInput = false
        this.showDurationRange = false
        this.formData.durationMin = null
        this.formData.durationMax = null
      } else if (val === 3) {
        this.showDurationInput = true
        this.showDurationRange = true
      } else if (val === 2) {
        this.showDurationInput = true
        this.showDurationRange = false
        this.formData.durationMin = 1
        this.formData.durationMax = null
      } else {
        this.showDurationInput = true
        this.formData.durationMin = null
        this.showDurationRange = false
        this.formData.durationMax = null
      }
    },
    handlePopupCountModeChange(val) {
      if (val === 0) {
        if (this.formData.popupCount > 0) {
          this.lastLimitedPopupCount = this.formData.popupCount
        }
        this.formData.popupCount = 0
      } else {
        this.formData.popupCount = this.lastLimitedPopupCount || 1
      }

      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField('popupCount')
        }
      })
    },
    toggleCrowdExpand(id) {
      const idx = this.expandedCrowdIds.indexOf(id)
      if (idx > -1) {
        this.expandedCrowdIds.splice(idx, 1)
      } else {
        this.expandedCrowdIds.push(id)
      }
    },
    mapDataToForm(data) {
      const popupCount = data.popupCount === 0 ? 0 : data.popupCount || 1
      this.formData = {
        id: data.id,
        popupRuleName: data.popupRuleName,
        position: data.position || null,
        triggerTiming: data.triggerTiming || null,
        watchingDurationType: data.watchingDurationType,
        durationMin: data.durationMin,
        durationMax: data.durationMax,
        crowdIds: data.crowdIds || [],
        crowdLimit: data.crowdLimit,
        popupCount,
        popupId: data.popupId,
        priority: data.priority || 1
      }
      this.popupCountMode = popupCount === 0 ? 0 : 1
      this.lastLimitedPopupCount = popupCount > 0 ? popupCount : 1

      // 设置时长显示
      this.handleDurationTypeChange(data.watchingDurationType)

      // Ensure the selected popup is in the options list
      if (data.popupId && data.popupName) {
        const exists = this.popupOptions.find((p) => p.id === data.popupId)
        if (!exists) {
          this.popupOptions.push({
            id: data.popupId,
            popupName: data.popupName,
            popupType: data.popupType,
            popupFileUrl: data.popupFileUrl || '',
            goodsType: data.goodsType,
            discountStyle: data.discountStyle,
            popupStyle: data.popupStyle,
            rewardType: data.rewardType
          })
        }
      }

      this.formData.durationMin = data.durationMin
      this.formData.durationMax = data.durationMax
    },
    resetFormData() {
      this.formData = {
        id: '',
        popupRuleName: '',
        position: null,
        triggerTiming: null,
        watchingDurationType: 0,
        durationMin: null,
        durationMax: null,
        crowdIds: [],
        crowdLimit: 1,
        popupCount: 1,
        popupId: null,
        priority: 1
      }
      this.showDurationInput = false
      this.showDurationRange = false
      this.popupCountMode = 1
      this.lastLimitedPopupCount = 1
      this.expandedCrowdIds = []
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const submitData = { ...this.formData }

            if (this.formData.crowdLimit === 1) {
              submitData.crowdIds = []
            }
            submitData.popupCount =
              this.popupCountMode === 0
                ? 0
                : this.formData.popupCount || this.lastLimitedPopupCount || 1

            const apiFunc = submitData.id ? editPush : addPush
            const r = await apiFunc(submitData)
            if (r.message == 'Success') this.$Message.success('保存成功')
            else this.$Message.warning(r.message)
            this.visible = false
            this.$emit('on-success')
          } catch (error) {
            console.log(error)

            this.$Message.error('保存失败')
          } finally {
            this.loading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.popup-option-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.popup-preview-icon {
  cursor: pointer;
  color: #808695;
  flex-shrink: 0;
  &:hover {
    color: #2d8cf0;
  }
}

.popup-preview-card {
  text-align: center;
  .popup-preview-img {
    width: 100%;
    max-height: 300px;
    object-fit: contain;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .popup-preview-empty {
    padding: 30px 0;
    color: #c5c8ce;
    font-size: 13px;
  }
  .popup-preview-name {
    font-size: 12px;
    color: #808695;
    margin-top: 4px;
  }
  .popup-preview-type {
    font-size: 11px;
    color: #c5c8ce;
    margin-top: 2px;
  }
  .popup-composite-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
    margin-bottom: 8px;
    .popup-preview-img {
      width: 100%;
      border-radius: 4px;
      display: block;
    }
    .popup-composite-btn {
      position: absolute;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
      width: 86%;
      .popup-composite-btn-img {
        width: 100%;
        display: block;
      }
    }
  }
}

.crowd-preview-card {
  // width: 320px;
  white-space: normal;
  .crowd-preview-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 10px;
    color: #17233d;
    border-bottom: 1px solid #e8eaec;
    padding-bottom: 8px;
  }
  .crowd-preview-body {
    font-size: 13px;
  }
  .crowd-preview-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    line-height: 1.5;
  }
  .crowd-preview-label {
    color: #808695;
    min-width: 70px;
    flex-shrink: 0;
    &::after {
      content: '：';
    }
  }
  .crowd-preview-value {
    color: #515a6e;
    word-break: break-all;
  }
  .crowd-country-text-wrapper {
    flex: 1;
    line-height: 1.5;
    min-width: 0;
    .ellipsis-text {
      display: block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.action-option-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-preview-icon {
  cursor: pointer;
  color: #808695;
  flex-shrink: 0;
  &:hover {
    color: #2d8cf0;
  }
}

.action-preview-card {
  text-align: center;
  padding: 4px 0;
  .action-preview-desc {
    font-size: 13px;
    color: #515a6e;
    margin-bottom: 6px;
  }
  .action-preview-tip {
    font-size: 12px;
  }
}

.popup-count-mode-row {
  display: block;
}

.popup-count-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.popup-count-input {
  width: 200px;
}

.popup-count-unit {
  color: #999;
}

</style>

<style>
/* 全局覆盖 iView Poptip 的内部换行样式，解决多选时文本超长不换行出现滚动条的问题 */
.ivu-poptip-body-content-word-wrap {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}
.ivu-poptip-inner {
  white-space: normal !important;
}
</style>
